import { ApiError } from './api-error.js';
export class RequiredError extends ApiError {
    name = 'RequiredError';
    field;
    constructor(field, message = `Required parameter "${field}" was null or undefined.`) {
        super({ status: 0, error: 'RequiredError', message });
        this.field = field;
    }
}
//# sourceMappingURL=required-error.js.map